import { useEffect, useState } from "react"
import { useApi } from "./useApi"

export const useSociete = () => {
    const api = useApi()
    const [societe, setSociete] = useState()

    useEffect(() => {
        api.get('/societes').then(items => setSociete(items[0]))
    }, [])

    return societe
}